<template>
    <div class="tab-detail">
        <div class="header">
            <div class="title">{{ $t("whatsapp_business_api.wpBussChannelDetail") }}</div>
            <div class="subtitle">{{ $t("whatsapp_business_api.manageChannelDetail") }}</div>
        </div>

        <!-- Onboarding Aşaması -->
        <template v-if="shouldShowOnboarding">
            <div class="onboarding-wrapper">
                <div class="facebook-signup-container">
                    <h3>{{ $t("whatsapp_business_api.completeSetup") }}</h3>
                    <p>{{ $t("whatsapp_business_api.completeSetupDescription") }}</p>

                    <div class="text-center my-4">
                        <a-button
                            type="primary"
                            size="large"
                            @click="redirectToConnectPage"
                        >
                            <a-icon type="link" />
                            {{ $t("whatsapp_business_api.connectWhatsAppBusinessAccount") }}
                        </a-button>
                    </div>

                    <a-alert
                        class="mt-4"
                        :message="$t('whatsapp_business_api.infoLabel')"
                        :description="$t('whatsapp_business_api.onboardingInfoDescription')"
                        type="info"
                        show-icon
                    />
                </div>
            </div>
        </template>

        <!-- Detay Formu -->
        <template v-else>
            <a-form>
                <div class="form-wrapper">
                    <div class="input-wrapper">
                        <label>{{ $t("whatsapp_business_api.channelName") }}</label>
                        <a-input
                            :placeholder="$t('whatsapp_business_api.channelName')"
                            v-model="clone.name"
                            v-validate="'required'"
                            name="channelName"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>{{ $t("whatsapp_business_api.businessId") }}</label>
                        <a-input
                            :placeholder="$t('whatsapp_business_api.businessId')"
                            :value="clone.payload.business_id"
                            disabled
                            name="businessId"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>{{ $t("whatsapp_business_api.phoneNumberId") }}</label>
                        <a-input
                            :placeholder="$t('whatsapp_business_api.phoneNumberId')"
                            :value="clone.payload.phone_number_id"
                            disabled
                            name="phoneNumberId"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>{{ $t("whatsapp_business_api.wabaId") }}</label>
                        <a-input
                            :placeholder="$t('whatsapp_business_api.wabaId')"
                            :value="clone.payload.waba_id"
                            disabled
                            name="wabaId"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>{{ $t("whatsapp_business_api.phoneNumberE164") }}</label>
                        <a-input
                            :placeholder="$t('whatsapp_business_api.phoneNumberE164Place')"
                            :value="clone.payload.phoneNumber"
                            disabled
                            name="phoneNumber"
                        />
                    </div>
                    <div class="input-wrapper" v-if="clone.payload.verifiedName">
                        <label>{{ $t("whatsapp_business_api.verifiedNameLabel") }}</label>
                        <a-input
                            :placeholder="$t('whatsapp_business_api.verifiedNameLabel')"
                            :value="clone.payload.verifiedName"
                            disabled
                            name="verifiedName"
                        />
                    </div>
                </div>
            </a-form>
            <ChannelForwardSetting :channel="clone" @input="(c) => (clone = c)" />
            <div class="form-footer">
                <div class="actions">
                    <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                        {{ $t("message.update") }}
                    </a-button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
import log2 from "../../../../utils/log2";

import { mapActions, mapState } from "vuex";
import ChannelForwardSetting from "../../IntegrationChannelsItem/ChannelForwardSetting.vue";

const log = log2("UpdateDetail.vue");
export default Vue.extend({
    name: "UpdateDetail",
    components: { ChannelForwardSetting },
    props: {
        value: {
            required: true,
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            loading: false,
            showStories: !!this.value.forward.story,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            stories: (state) => state.CB.stories,
            subjects: (state) => _.get(state.subject.subjects, "data", []) || [],
            departments: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
        shouldShowOnboarding() {
            // Eğer account-deleted veya account-ban ise her zaman onboarding göster
            const onboardReason = _.get(this.clone, "onboard.onboardReason", null);
            if (onboardReason === "account-deleted" || onboardReason === "account-ban") {
                return true;
            }

            const isOnboarded =
                _.get(this.clone, "onboard.live", false) ||
                (_.get(this.clone, "payload.businessToken", null) && _.get(this.clone, "payload.phoneNumber", null));
            return !isOnboarded;
        },
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
            listStories: "CB/listStories",
        }),
        toggleChatbot() {
            if (this.showStories) {
                this.clone.forward.story = null;
            } else {
                if (this.stories[0]) {
                    this.clone.forward.story = this.stories[0]._id;
                }
            }
            this.showStories = !this.showStories;
        },

        handleSave() {
            const isValid = true;
            if (isValid) {
                const isChanged = !_.isEqual(this.value, this.clone);
                if (!isChanged) {
                    return;
                }
                const payload = this.clone;
                this.loading = true;
                this.updateChannel(payload)
                    .then(() => {
                        this.listChannels();
                        this.$message.success(this.$t("whatsapp_business_api.channelUpdatedSucs"));
                        this.$emit("input", this.clone);
                        this.clone = _.cloneDeep(this.clone);
                    })
                    .catch((err) => {
                        console.error(err);
                        this.$message.error(this.$t("whatsapp_business_api.faieldUpdateChannel"));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },

        redirectToConnectPage() {
            const payload = {
                siteId: this.site._id,
                channelId: this.clone._id,
                userId: this.$store.state.auth.user._id,
                env: process.env.ENVIRONMENT || "production"
            };

            const token = btoa(JSON.stringify(payload));
            const connectUrl = `https://connect-waba.supsis.ai?token=${token}`;

            console.log("Redirecting to connect page", { payload, token, connectUrl });
            window.open(connectUrl, '_blank');
        },
    },
    mounted() {
        this.listStories();
    },
    watch: {
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    log("value changed=>", val);
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.tab-detail {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;

    .header {
        display: flex;
        justify-content: space-between;
        padding-bottom: 10px;

        border-bottom: 1px solid var(--color-border-default);

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }

    .onboarding-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 50vh;
        padding: 20px;

        .facebook-signup-container {
            text-align: center;
            padding: 30px;
            border: 1px solid var(--color-border-default);
            border-radius: 12px;
            background-color: var(--color-bg-subtle);
            max-width: 500px;
            width: 100%;

            h3 {
                font-size: 20px;
                font-weight: 600;
                margin-bottom: 10px;
                color: var(--color-text-strong-default);
            }

            p {
                color: var(--color-text-default);
                margin-bottom: 20px;
            }

            .session-info {
                background-color: var(--color-bg-default);
                padding: 10px;
                border-radius: 4px;
                max-height: 200px;
                overflow-y: auto;
                white-space: pre-wrap;
                text-align: left;
                font-size: 12px;
            }
        }
    }

    .webhook-info {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 5px;

        span {
            cursor: pointer;
        }
    }

    .input-wrapper {
        margin-bottom: 15px;

        label {
            display: block;
            margin-bottom: 5px;
            font-weight: 600;
        }
    }

    .form-footer {
        margin-top: 20px;
        .actions {
            display: flex;
            justify-content: flex-end;
        }
    }

    .text-center {
        text-align: center;
    }

    .my-4 {
        margin-top: 16px;
        margin-bottom: 16px;
    }

    .mt-4 {
        margin-top: 16px;
    }
}
</style>
